export const REGISTRATION_SECTION_ID = 'registro';

const HEADER_OFFSET_MOBILE = 96;
const HEADER_OFFSET_DESKTOP = 128;
const SCROLL_EXTRA_PADDING = 32;

const getScrollOffset = () => {
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  const headerHeight = isDesktop ? HEADER_OFFSET_DESKTOP : HEADER_OFFSET_MOBILE;
  return headerHeight + SCROLL_EXTRA_PADDING;
};

export const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (!element) return;

  const top = element.getBoundingClientRect().top + window.scrollY - getScrollOffset();
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
};

export const scrollToRegistration = () => {
  scrollToSection(REGISTRATION_SECTION_ID);
};
